export const siteSettings = {
  name: "Trade Probits",
  link: "https://tradeprobits.com",
  email: "support@tradeprobits.com",
  appLink: "https://app.tradeprobits.com",
};
